module.exports = __webpack_public_path__ + "img/AvenirNextCyr-HeavyItalic.e0ccbc16.svg";